<template>
    <!-- htmlText is data.name -->
    <div class="d-flex align-items-center" v-if="data.type == 'LOCATION'">
        <span class="ml" v-html="htmlText"></span>
    </div>
</template>

<style scoped>

</style>

<script>
export default {
    components: {

    },
    props: {
        data: {
            type: Object,
        },
        htmlText: {
            type: String,
        }
    }
}
</script>